import { inject, Injectable } from '@angular/core';
import { UserStore } from '@lib/user/data-access';
import { NgbDate, NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DATE_FNS_FORMAT } from '@shared/utils/constants';
import { format, getDate, getMonth, getYear, isValid } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class DateAdapterService extends NgbDateAdapter<string> {
  private readonly userStore = inject(UserStore);
  override fromModel(value: string | null): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    if (isValid(date)) {
      return new NgbDate(getYear(date), getMonth(date) + 1, getDate(date));
    }
    return null;
  }

  override toModel(date: NgbDateStruct | null): string | null {
    if (!date) {
      return '';
    }

    const { day, month, year } = date;
    const preFormattedDate = new Date(Date.UTC(year, month - 1, day));
    const dateFormat = DATE_FNS_FORMAT[this.userStore.dateFormat()!];

    const formattedDate1 = format(preFormattedDate, dateFormat);

    return formattedDate1;
  }
}
